module.exports = __webpack_public_path__ + "img/youtube.a529f200.svg";